// extracted by mini-css-extract-plugin
export var formContainer = "_hr-0";
export var message = "_hr-1";